import {
  AlertTriangle,
  CheckCircle2,
  Clock3,
  ShieldAlert,
  Sparkles,
} from "lucide-react";

import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { CrawlStatus } from "@/mocks/products";

const statusLabels: Record<CrawlStatus, string> = {
  fresh: "Fresh",
  cooldown: "Cooldown",
  blocked: "Blocked",
  sparse: "Sparse data",
  new: "New tracking",
};

const statusStyles: Record<CrawlStatus, string> = {
  fresh: "border-[#135d2b] bg-[#052312] text-[#35f36c]",
  cooldown: "border-[#765313] bg-[#241702] text-[#ffc04d]",
  blocked: "border-[#6e1b18] bg-[#260807] text-[#ff5b45]",
  sparse: "border-[#765313] bg-[#241702] text-[#ffc04d]",
  new: "border-[#154b7c] bg-[#061829] text-[#4fb7ff]",
};

const statusIcons: Record<CrawlStatus, JSX.Element> = {
  fresh: <CheckCircle2 className="h-3.5 w-3.5" />,
  cooldown: <Clock3 className="h-3.5 w-3.5" />,
  blocked: <ShieldAlert className="h-3.5 w-3.5" />,
  sparse: <AlertTriangle className="h-3.5 w-3.5" />,
  new: <Sparkles className="h-3.5 w-3.5" />,
};

export const statusDescriptions: Record<CrawlStatus, string> = {
  fresh: "Latest crawl completed successfully.",
  cooldown: "Interest recorded inside the 24h crawl window.",
  blocked: "Last crawl hit the Shopee anti-bot boundary.",
  sparse: "History exists, but the collected sample is still thin.",
  new: "First snapshot will be created after the initial crawl.",
};

type StatusBadgeProps = {
  status: CrawlStatus;
  className?: string;
};

export function StatusBadge({ status, className }: StatusBadgeProps): JSX.Element {
  return (
    <Badge
      className={cn(
        "h-7 gap-1.5 rounded-full border px-3 text-xs font-extrabold shadow-[0_0_24px_rgba(35,255,107,0.08)]",
        statusStyles[status],
        className,
      )}
      variant="outline"
    >
      {statusIcons[status]}
      {statusLabels[status]}
    </Badge>
  );
}
